<template>
  <div class="app-main-inner">
    <div class="app-main-page">
      <div class="app-main-inner-row operations">
        <div v-show="cooperateEdit" class="triggers">
          <div>
            <el-button no="1" type="primary" :disabled="isEdit" @click="autoAllocateCargoHandler">{{ $t('SeaExport.AutoDistribution') }}</el-button>
            <el-button no="2" type="primary" :disabled="isEdit" @click="allocateCargoHandler">{{ $t('SeaExport.ManualDistribution') }}</el-button>
            <el-button no="3" type="primary" :disabled="!btUnlockEnabled" @click="removeRelationHandler">{{ $t('SeaExport.Unlock2') }}</el-button>
          </div>
        </div>
      </div>
      <div style="flex-grow:1;padding:10px;">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;height:100%"
          @gridReady="params=>gridApi=params.api"
        />
      </div>
    </div>
    <!-- 查询仓库记录弹窗 -->
    <warehouse-record-dialog :visible.sync="warehouseRecordDialog.visible" :lob="job.lob" @selectWarehouseHandler="selectWarehouseHandler" />
  </div>
</template>

<script>

import {
  warehouseInList,
  warehouseInUnLock,
  autoAllocateCargo,
  uploadPhotoData,
  updateWarehuse,
  batchWarehuseIn, batchUploadPhotoData
} from '@/api/seaExport/warehouseIn'
import { cacheName, cache } from '@/utils/cacheManager'
import warehouseRecordDialog from '@/components/Cargo/Job/warehouseSearchDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'TabWarehouseIn',
  components: { warehouseRecordDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: '',
          width: 220,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            innerRenderer: (params) => {
              return this.firstColumnLabelFun(params.data.uuid)
            }
          }
        },
        onRowClicked: this.onRowClicked
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.quantityLabFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Weight'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.weightLabFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.cubageLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Size'),
          field: 'dimension',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.WhetherOrNotBroken'),
          field: 'broken',
          width: 120,
          cellRenderer: (params) => {
            return this.isBrokenLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BrokenDesc'),
          field: 'brokenDes',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.BangPic'),
          field: '',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.WareHouseName'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.referenceNoLabFun(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.WareHouseMarks'),
          field: 'marks',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      warehouseRecordDialog: {
        visible: false
      },
      currentUser: {},
      job: { lob: '' },
      selectedWarehousIn: null,
      btUnlockEnabled: false,
      refreshDocData: false,
      refreshDocActualData: false
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        await cache.load(cacheName.USER, cacheName.CONFIG)
        this.currentUser = cache.user
        this.job = row
        this.refreshDocData = parseInt(cache.config.get('refreshDocData')) === 1
        this.refreshDocActualData = parseInt(cache.config.get('refreshDocActualData')) === 1
        this.loadWarehouseIn()
      }
    },
    async loadWarehouseIn() {
      /* // 加载数据
      const jobClass = new SeaExportJob(this.job)
      this.rowData = await jobClass.getWarehouseIn()*/
      await warehouseInList(this.job.uuid).then(res => {
        this.rowData = res.data
      })
    },
    firstColumnLabelFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        return obj.warehouseNo + ' ' + ColumnUtils.dateLabelFunc(obj.warehouseInDate)
      } else {
        return ColumnUtils.packingCodeLabelFun(obj.packing)
      }
    },
    quantityLabFunc(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let quantity = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          quantity = quantity + item.quantity
        }
        return NumberUtils.formatNumber(quantity)
      } else {
        return obj.quantity
      }
    },
    weightLabFunc(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let weight = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          weight = weight + item.weight
        }
        return NumberUtils.formatNumber(weight, 2)
      } else {
        return obj.weight
      }
    },
    cubageLabelFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      if (obj.parent) {
        let cubage = 0
        const detailList = this.rowData.filter(val => {
          return val.warehouseInUuid === uuid
        })
        for (const item of detailList) {
          cubage = cubage + item.cubage
        }
        return NumberUtils.formatNumber(cubage, 3)
      } else {
        return obj.cubage
      }
    },
    isBrokenLabelFunc(broken) {
      if (broken == null) return ''
      return broken ? '√' : ''
    },
    referenceNoLabFun(uuid) {
      var obj = this.rowData.find(x => x.uuid === uuid)
      const referenceNo = obj.referenceNo
      if (!StrUtils.isEmpty(referenceNo)) {
        if (referenceNo.indexOf('EYGX') > -1) {
          return this.$t('SeaExport.EnyuanGaoxiangku')
        } else if (referenceNo.indexOf('EYYY') > -1) {
          return this.$t('SeaExport.EnyuanYangyuanKu')
        } else if (referenceNo.indexOf('EYHQ') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        } else if (referenceNo.indexOf('EYLD') > -1) {
          return this.$t('SeaExport.EnYuanHuaXiaKu')
        }
      }
    },
    onRowClicked(event) {
      this.selectedWarehousIn = event.data
      if (this.selectedWarehousIn.parent) { this.btUnlockEnabled = true && this.readonly } else { this.btUnlockEnabled = false }
    },
    autoAllocateCargoHandler() {
      autoAllocateCargo(this.job.uuid).then(res => {
        if (res.data === null || res.data.length === 0) {
          this.$message(this.$t('Message.DistributeFailedNoFoundRelatedStorageRecord'))
        } else {
          this.$message(this.$t('Message.DistributedSuccessfully'))
          this.loadWarehouseIn()
        }
      })
    },
    allocateCargoHandler() {
      this.warehouseRecordDialog.visible = true
    },
    removeRelationHandler() {
      if (this.selectedWarehousIn === null) {
        return
      }
      this.$confirm(this.$t('Message.SureYouWantToCancelTheBindingToTheStorageData'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          const uuid = this.selectedWarehousIn.uuid
          // 更新 warehouseIn 表上的 jobUuid 为空
          await warehouseInUnLock(uuid)
          // 是否更新实际件毛体
          if (this.refreshDocActualData) {
            this.refreshWarehouseInQWC()
          }
          // 重新加载列表
          this.loadWarehouseIn()
        } finally {
          this.loadList()
        }
      }).catch(() => {
      })
    },
    refreshWarehouseInQWC() {
      if (this.job.lob !== 'SE') {
        let totalQuantity = 0
        let totalWeight = 0
        let totalCubage = 0
        for (const warehouse of this.rowData) {
          if (warehouse.parent) {
            totalQuantity += warehouse.quantitySum
            totalCubage += warehouse.cubageSum
            totalWeight += warehouse.weightSum
          }
        }
        this.job.quantityActual = totalQuantity
        this.job.weightActual = totalWeight
        this.job.cubageActual = totalCubage
        // todo 提交后端 保存 SE 的业务不保存，等其他业务类型的保存api 开发后此处补上
      }
    },
    async selectWarehouseHandler(warehouseList) {
      const photoList = []
      for (const warehouse of warehouseList) {
        // 更新 wareHouseIn 上的信息
        warehouse.jobUuid = this.job.uuid
        if (StrUtils.isEmpty(warehouse.lob)) {
          warehouse.lob = this.job.lob
        }
        if (warehouse.branchId === 0) {
          warehouse.branchId = this.job.opOffice
        }
        delete warehouse.warehouseInDetail
        delete warehouse.business_Document
        photoList.push({ jobUuid: this.job.uuid, warehouseInUuid: warehouse.uuid })
      }
      await batchWarehuseIn(warehouseList)
      // 更新job 上的信息
      this.refreshWarehouseInQWC()
      await batchUploadPhotoData(photoList)
      // 重新加载
      this.loadWarehouseIn()
      this.warehouseRecordDialog.visible = false
    }

  }
}
</script>

<style>
</style>
